import { useState, useEffect } from "react";
import { POAuditEntry } from "@po-management/types";
import { useApiClient } from "../auth/useApiClient";

interface UseAuditLogResult {
  entries: POAuditEntry[];
  loading: boolean;
  error: string | null;
}

export function useAuditLog(poId: string): UseAuditLogResult {
  const { get } = useApiClient();
  const [entries, setEntries] = useState<POAuditEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!poId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    get(`/api/pos/${poId}/audit`)
      .then((res) => res.json() as Promise<{ success: boolean; data: POAuditEntry[]; error?: string }>)
      .then((body) => {
        if (cancelled) return;
        if (body.success) setEntries(body.data);
        else setError(body.error ?? "Failed to load audit log");
      })
      .catch(() => { if (!cancelled) setError("Network error"); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poId]);

  return { entries, loading, error };
}
